<script>
import date from '@/mixins/date'
import CompanyResource from '@/resources/company'
import ListingResource from '@/resources/listing'

export default {
    components: {},
    mixins: [date],
    data() {
        return {
            loading: true,
            companyResource: null
        }
    },
    props: {
        listingResource: {
            type: ListingResource,
            required: true,
        },
        showOwnerControls: {
            type: Boolean,
            default: false
        },
        noTitle: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onPublish() {
            this.$emit('publish', this.listingResource)
        },
    },
    async mounted() {
        await this.listingResource.resolveRelated()
        this.companyResource = await CompanyResource.detail(this.listingResource.attributes.company)
        this.loading = false
    },
}
</script>

<template>
    <div>
        <b-row v-if="!loading">
            <b-col md="9">
                <slot name="before" />
                <div v-if="!noTitle">
                    <slot name="title">
                        <h4>{{ listingResource.attributes.title }}</h4>
                    </slot>
                    <slot name="controls">
                        <span v-if="showOwnerControls">
                            <b-badge :variant="listingResource.status.variant" class="published-badge">{{ listingResource.status.text }}</b-badge>
                        </span>
                    </slot>
                </div>
                <hr v-if="!noTitle" />
                <div class="preview-body" v-html="listingResource.attributes.body" />
                <slot />
            </b-col>

            <b-col class="listing-details">
                <slot name="details-header">
                </slot>
                <slot name="details">
                    <dl>
                        <dt>Job Type</dt>
                        <dd>{{ listingResource.get('type.name') }}</dd>
                    </dl>
                    <dl>
                        <dt>Role</dt>
                        <dd>{{ listingResource.get('role.name') }}</dd>
                    </dl>
                    <dl>
                        <dt>Compensation</dt>
                        <dd>${{ listingResource.compensationMin }} - ${{ listingResource.compensationMax }}</dd>
                        <dd>{{ listingResource.get('equity_percentage_min') }}% to {{ listingResource.get('equity_percentage_max') }}% Equity</dd>
                    </dl>
                    <dl v-if="listingResource.get('location')">
                        <dt>Job Location</dt>
                        <dd>{{ listingResource.get('location') }}</dd>
                    </dl>
                    <dl>
                        <dt>Candidate Regions</dt>
                        <dd v-for="(region, i) in listingResource.get('regions.name')" :key="i">{{ region }}</dd>
                    </dl>
                    <dl v-if="listingResource.attributes.markets && listingResource.attributes.markets.length > 0">
                        <dt>Markets</dt>
                        <dd v-for="(market, i) in listingResource.get('markets.name')" :key="i">{{ market }}</dd>
                    </dl>
                    <dl v-if="listingResource.attributes.skills && listingResource.attributes.skills.length > 0">
                        <dt>Skills</dt>
                        <dd v-for="(skill, i) in listingResource.get('skills.name')" :key="i">{{ skill }}</dd>
                    </dl>
                </slot>
                <slot name="details-footer">
                </slot>
            </b-col>
        </b-row>
        
        <div v-else>
            Loading...
        </div>
        
    </div>
</template>

<style lang="scss">

</style>
